import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import axiosInstance from '../../api/axiosInstance';
// Async thunk to fetch reviews
export const fetchReviews = createAsyncThunk(
  'reviews/fetchReviews',
  async ({ language  }) => {
    const response = await axiosInstance.post(
      '/api/Common/GetReviews',
      {},
      {
        headers: { Accept: 'text/plain' },
        "lang": language === "English" ? "2" : "1",
      }
    );
    return response.data.message; // Assuming the data is in the "message" field
  }
);

const reviewsSlice = createSlice({
  name: 'reviews',
  initialState: {
    reviews: [],
    status: 'idle', // idle | loading | succeeded | failed
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchReviews.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchReviews.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.reviews = action.payload;
      })
      .addCase(fetchReviews.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      });
  },
});

export default reviewsSlice.reducer;
